module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "hero landing-youtube"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [(_vm.playing) ? _c('div', {
    staticClass: "column",
    staticStyle: {
      "padding-right": "50px"
    }
  }, [_c('div', {
    staticClass: "currentSong"
  }, [_vm._m(1), _vm._v(" "), _c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "orange",
      "font-size": "1.75rem"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "orange"
    }
  }, [_vm._v(_vm._s(_vm.playing.dj))]), _vm._v(" is playing")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle",
    staticStyle: {
      "padding-bottom": "2rem",
      "font-size": "1.5rem"
    }
  }, [_vm._v(_vm._s(_vm.playing.author) + " - " + _vm._s(_vm.playing.title) + " \n                "), _c('a', {
    attrs: {
      "target": "blank",
      "href": _vm.playing.link
    }
  }, [_c('div', {
    staticClass: "tooltip"
  }, [_c('img', {
    attrs: {
      "src": _vm.playing.image
    }
  })]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._l((_vm.played), function(play) {
    return (!_vm.isMobile) ? _c('div', {
      staticClass: "wasPlaying",
      staticStyle: {
        "padding-bottom": "0.85rem"
      }
    }, [_c('h1', {
      staticStyle: {
        "color": "orange",
        "font-size": "1rem"
      }
    }, [_c('strong', {
      staticStyle: {
        "color": "orange"
      }
    }, [_vm._v(_vm._s(play.dj))]), _vm._v(" played\n                  "), _c('div', {
      staticClass: "score",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#90ad2f"
      }
    }, [_vm._m(3, true), _vm._v(_vm._s(play.score.woots))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#aa74ff"
      }
    }, [_vm._m(4, true), _vm._v(_vm._s(play.score.grabs))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#c42e3b"
      }
    }, [_vm._m(5, true), _vm._v(_vm._s(play.score.mehs))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#bbb"
      }
    }, [_vm._m(6, true), _vm._v(_vm._s(play.score.listeners))])])]), _vm._v(" "), _c('h2', {
      staticClass: "subtitle",
      staticStyle: {
        "font-size": "1rem",
        "border-bottom": "1px solid #bbb",
        "padding-bottom": "5px"
      }
    }, [_vm._v(_vm._s(play.author) + " - " + _vm._s(play.title) + " "), _c('a', {
      attrs: {
        "target": "blank",
        "href": play.link
      }
    }, [_c('div', {
      staticClass: "tooltip"
    }, [_c('img', {
      attrs: {
        "src": play.image
      }
    })]), _vm._m(7, true)])])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-half",
    staticStyle: {
      "padding-bottom": "5rem"
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "embed-container"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/SQKG9mqsWgs",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "hero landing-weekly-events",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_vm._m(9), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              We host a themed party on every Sunday! We pick one or two specific types of music to play. Queue up your favorite tunes and earn "), _c('router-link', {
    attrs: {
      "to": "/bot/games"
    }
  }, [_vm._v("ChillCoins™")]), _vm._v(" when your plays are on theme."), _c('br'), _c('br'), _c('br')], 1)]), _vm._v(" "), _vm._m(10)])])])]), _vm._v(" "), _vm._m(11)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "motion-background"
  }, [_c('div', {
    staticClass: "bg-video"
  }, [_c('video', {
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/video/bg-particles-blue.webm",
      "type": "video/webm"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title text-on-motion"
  }, [_c('span', {
    staticStyle: {
      "color": "#FFF"
    }
  }, [_vm._v("Chillout Music")]), _vm._v(" is a Plug.dj community — a place to play music and videos with friends and others from around the world in a fun, real-time, community-driven environment.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "orange"
    }
  }, [_c('div', {
    staticClass: "equaliser-container"
  }, [_c('ol', {
    staticClass: "equaliser-column"
  }, [_c('li', {
    staticClass: "colour-bar"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "equaliser-column"
  }, [_c('li', {
    staticClass: "colour-bar"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "equaliser-column"
  }, [_c('li', {
    staticClass: "colour-bar"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "equaliser-column"
  }, [_c('li', {
    staticClass: "colour-bar"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "equaliser-column"
  }, [_c('li', {
    staticClass: "colour-bar"
  })])]), _vm._v("\n                 Currently playing on "), _c('a', {
    attrs: {
      "target": "blank",
      "href": "https://plug.dj/electronic-chillout-music"
    }
  }, [_vm._v("Plug.dj")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-star"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yt"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "orange"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })]), _vm._v(" Our YouTube Channel")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("The best of chillout music curated and featured by our very own "), _c('strong', [_vm._v("Molly")]), _vm._v("."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v("Weekly Events")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": require("../img/plug-avatars.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero landing-rdj-events"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  })]), _vm._v("Upcoming and past events")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n          Occasionally we host big events where your favorite big name artists bring you the newest tunes. Don't miss out on hearing the best of music and the opportunity to mingle with producers and DJs.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": "/img/events/ComingSoon.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": "/img/events/episode19.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": "/img/events/episode18.jpg"
    }
  })])]), _vm._v(" "), _c('br'), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85e1a8c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 171
// module chunks = 1